import { Reveal, SectionTag } from "./Reveal";

const VALUES = ["Professional", "Responsive", "Reliable", "Technology-enabled", "Customer-focused"];

export default function AboutSection() {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-7">
          <Reveal>
            <SectionTag number="15" label="About Ajemi" />
            <h2 className="font-outfit text-3xl md:text-5xl font-extralight tracking-tight text-white leading-tight">
              Making energy procurement <span className="text-gold">easier for businesses.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="mt-8 text-white/60 text-base md:text-lg leading-relaxed max-w-2xl">
              Ajemi Energy — the commercial brand of Ajemi Oil &amp; Gas Ltd. — is a Nigerian
              energy procurement and supply company focused on helping businesses source
              petroleum products through trusted commercial supply relationships.
            </p>
            <p className="mt-5 text-white/60 text-base md:text-lg leading-relaxed max-w-2xl">
              We do the difficult work — finding appropriate supply, comparing available
              options, coordinating with suppliers, negotiating commercial terms, managing
              documentation and helping coordinate delivery — so our customers can focus on
              running their operations.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 flex flex-wrap gap-3" data-testid="about-values">
              {VALUES.map((v) => (
                <span
                  key={v}
                  className="font-outfit text-sm text-white/70 border border-white/12 rounded-full px-5 py-2 hover:border-gold/50 hover:text-gold transition-colors duration-300"
                >
                  {v}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-5">
          <Reveal delay={0.15}>
            <div className="relative rounded-2xl overflow-hidden border border-white/10" data-testid="about-image-frame">
              <img
                src="https://images.unsplash.com/photo-1660496247667-3fb697c396af?q=80&w=1200&auto=format&fit=crop"
                alt="Modern office tower at night"
                loading="lazy"
                className="w-full h-[420px] md:h-[520px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent" />
              <div className="absolute bottom-0 inset-x-0 p-7">
                <p className="font-outfit text-gold text-sm tracking-[0.3em] uppercase">Energy Today.</p>
                <p className="font-outfit text-white text-2xl font-light mt-1">Powering Tomorrow.</p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
